export default __webpack_public_path__ + "static/media/mountain_hamster_768.c3c49f66.webp";